import React, { memo } from 'react'

const FavIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
  >
    <path
      d="M9 16.9538C8.79 16.9538 8.57625 16.9163 8.35875 16.8413C8.14125 16.7663 7.95 16.6463 7.785 16.4813L6.2325 15.0638C4.6425 13.6088 3.20625 12.165 1.92375 10.7325C0.64125 9.30002 0 7.72126 0 5.99626C0 4.58626 0.4725 3.40876 1.4175 2.46376C2.3625 1.51876 3.54 1.04626 4.95 1.04626C5.745 1.04626 6.495 1.21501 7.2 1.55251C7.905 1.89001 8.505 2.35126 9 2.93626C9.495 2.35126 10.095 1.89001 10.8 1.55251C11.505 1.21501 12.255 1.04626 13.05 1.04626C14.46 1.04626 15.6375 1.51876 16.5825 2.46376C17.5275 3.40876 18 4.58626 18 5.99626C18 7.72126 17.3625 9.30376 16.0875 10.7438C14.8125 12.1838 13.365 13.6313 11.745 15.0863L10.215 16.4813C10.05 16.6463 9.85875 16.7663 9.64125 16.8413C9.42375 16.9163 9.21 16.9538 9 16.9538Z"
      fill="currentColor"
    />
  </svg>
))

export { FavIcon }
